// eslint-disable-next-line import/prefer-default-export
export const generateTdpQueryParam = ({
  requester, zone, choiceId, position, categoryId,
}) => {
  const aRequester = `cm_app~z${requester ?? ''}~`;
  const aZone = `xcm_zone~z${zone ?? ''}~`;
  const qChoiceId = `xcm_choiceId~z${encodeURIComponent(choiceId ?? '')}~`;
  const aPosition = `xcm_pos~zPos${position ?? ''}~`;
  const catIdParam = `xcm_srcCatID~z${categoryId ?? ''}`;

  return `tdp=${aRequester}${aZone}${qChoiceId}${aPosition}${catIdParam}`;
};
